import { createContext } from 'react';

import { initialActionsState } from './actions';
import { initialState } from './reducer';
import * as initialSelectors from './selectors';
import type { IMultiAccountsContextValue } from './types';

export default createContext<IMultiAccountsContextValue>({
  state: initialState,
  actions: initialActionsState,
  selectors: initialSelectors,
});
